import Config from '@shared/config/constants/config-main';
import loadable from '@loadable/component';
import React from 'react';

import { CARD_DISPLAY_STATUSES } from '@shared/config/constants/app';
import { isRTL, isStripePaymentGateway } from '@shared/utils';
import { PAYMENT_GATEWAYS } from '@entities/payment-plan';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useAtomValue } from 'jotai';
import { dcbAtom, languageAtom } from '@shared/store/slice-atoms';
const CardFormStripe = loadable(() =>
  import('@features/card-subscription/ui/CardFormStripe').then((module) => ({ default: module.CardFormStripe }))
);
const CardFormAdyen = loadable(() =>
  import('@features/card-subscription/ui/CardFormAdyen').then((module) => ({ default: module.CardFormAdyen }))
);

export const CardParent = ({
  isHlrlookup,
  isCcPromo = false,
  isTrial,
  trialDuration,
  paymentGateway = PAYMENT_GATEWAYS.STRIPE,
  formStatus = CARD_DISPLAY_STATUSES.open,
  googleApplePayStatus,
  dealBannerConfig,
  selectedPlan,
  apiSource,
  buttonTextKeys,
  termsAndConditionsTextKeys,
  termsAndConditionsCC = {},
}) => {
  const language = useAtomValue(languageAtom);
  const { homeData } = useAtomValue(dcbAtom);
  const isStripeCCGateway = isStripePaymentGateway(paymentGateway);

  const configurationsTermsAndConditionsHTML =
    termsAndConditionsCC?.[homeData?.country]?.[language.locale] || null;

  const promise = isStripeCCGateway
    ? loadStripe(`${Config.STRIPE_KEY}`, {
        locale: isRTL(language.direction) ? (language.locale === 'ar' ? 'ar' : 'en') : 'en',
      })
    : null;

  return (
    <>
      {!isStripeCCGateway ? (
        <CardFormAdyen
          isHlrlookup={isHlrlookup}
          isCcPromo={isCcPromo}
          isTrial={isTrial}
          trialDuration={trialDuration}
          adyenFormStatus={formStatus}
          googleApplePayStatus={googleApplePayStatus}
          selectedPlan={selectedPlan}
          apiSource={apiSource}
          dealBannerConfig={dealBannerConfig}
          buttonTextKeys={buttonTextKeys}
          termsAndConditionsTextKeys={termsAndConditionsTextKeys}
        />
      ) : (
        <Elements stripe={promise} key={language.locale}>
          <CardFormStripe
            isHlrlookup={isHlrlookup}
            isCcPromo={isCcPromo}
            isTrial={isTrial}
            trialDuration={trialDuration}
            stripeFormStatus={formStatus}
            googleApplePayStatus={googleApplePayStatus}
            selectedPlan={selectedPlan}
            apiSource={apiSource}
            dealBannerConfig={dealBannerConfig}
            buttonTextKeys={buttonTextKeys}
            termsAndConditionsTextKeys={termsAndConditionsTextKeys}
          />
        </Elements>
      )}

      {configurationsTermsAndConditionsHTML ? (
        <div
          style={{ marginTop: '16px' }}
          dangerouslySetInnerHTML={{
            __html: configurationsTermsAndConditionsHTML,
          }}
        />
      ) : null}
    </>
  );
};
